import React from 'react';
import styled from 'styled-components';
import PointPlayer from './Images/Michael.jpeg'
import PointTeam from './Images/Derrick.jpeg'
import AssistPlayer from './Images/Iman.jpeg'
import AssistTeam from './Images/Derrick.jpeg'
import BlockPlayer from './Images/Derrick.jpeg'
import BlockTeam from './Images/Derrick.jpeg'

function Top() {
  return (
    <TopMain>
      <TopContain>
        <TopContainUp>
          <h1>Top Performers</h1>
        </TopContainUp>
        <TopContainDown>
          <TopDownContain>
            <Performers>
              <PerformUp>
                <PerformUpLeft><img src={PointPlayer} alt='Points per game'></img></PerformUpLeft>
                <PerformUpMid>
                  <p>MICHAEL SIMON<br/>
                  'G/F'</p>
                </PerformUpMid>
                <PerformUpRight>
                  <img src={PointTeam} alt='Points team'></img>
                </PerformUpRight>
              </PerformUp>
              <PerformDown>
                <h1>Points</h1>
                <h2>22.2 PPG</h2>
              </PerformDown>
            </Performers>
            <Performers>
              <PerformUp>
                <PerformUpLeft><img src={AssistPlayer} alt='Points per game'></img></PerformUpLeft>
                <PerformUpMid>
                  <p>IMAN POWER<br/>
                  'G'</p>
                </PerformUpMid>
                <PerformUpRight>
                  <img src={AssistTeam} alt='Points team'></img>
                </PerformUpRight>
              </PerformUp>
              <PerformDown>
                <h1>Assist</h1>
                <h2>11.4 APG</h2>
              </PerformDown>
            </Performers>
            <Performers>
              <PerformUp>
                <PerformUpLeft><img src={BlockPlayer} alt='Points per game'></img></PerformUpLeft>
                <PerformUpMid>
                  <p>IFEME DERRICK<br/>
                  'C'</p>
                </PerformUpMid>
                <PerformUpRight>
                  <img src={BlockTeam} alt='Points team'></img>
                </PerformUpRight>
              </PerformUp>
              <PerformDown>
                <h1>Blocks</h1>
                <h2>2.3 BPG</h2>
              </PerformDown>
            </Performers>
          </TopDownContain>
        </TopContainDown>
      </TopContain>
    </TopMain>
  )
}

export default Top


const TopMain = styled.div`
height: 70vh;
width: 100%;
display: flex;
justify-content: center;
align-items: center;
background-color: antiquewhite;
font-family: cursive;
@media screen and (max-width: 750px) {
  height: 90vh;
}
`

const TopContain = styled.div`
height: 85%;
width: 90%;
display: flex;
flex-direction: column;
background-color: white;
`

const TopContainUp = styled.div`
height: 15%;
width: 100%;
text-align: center;
`

const TopContainDown = styled.div`
height: 85%;
width: 100%;
display: flex;
justify-content: center;
align-items: center;  
`

const TopDownContain = styled.div`
height: 90%;
width: 100%;
display: flex;
justify-content: space-around;
align-items: center;
/* flex-wrap: wrap; */
@media screen and (max-width: 750px) {
  flex-direction: column;
  justify-content: space-between;
}
`

const Performers = styled.div`
height: 35vh;
width: 300px;
background-color: white;
box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
@media screen and (max-width: 750px) {
  height: 17vh;
  width: 200px;
}
`

const PerformUp = styled.div`
height: 50%;
width: 100%;
display: flex;
`

const PerformDown = styled.div`
height: 50%;
width: 100%;
border-width: 4px 0px 0px 0px;
border-style: inset;
font-size: 12px;
display: flex;
flex-direction: column;
align-items: center;
`

const PerformUpLeft = styled.div`
height: 100%;
width: 35%;
img{
  height: 100%;
  width: 100%;
}
`

const PerformUpMid = styled.div`
height: 100%;
width: 45%;
display: flex;
flex-direction: column;
justify-content: center;
align-items: start;
font-size: smaller;
`

const PerformUpRight = styled.div`
height: 100%;
width: 20%;
display: flex;
justify-content: center;
align-items: center;
img{
  height: 40%;
}
`
